<template>
<div class="k-page-content" v-loading="loading">
        <el-tabs v-model="activeName" class="box-eltab">
            <el-tab-pane label="平台详情" name="first" v-if="infoData.plateform.platform_name">
                <div class="k-page-common">
                    <div class="k-common-header" style="padding: 12px;">
                        <div class="proDeTitle">
							<div>
								<span class="t1">平台名称：</span>
								<span class="t2">{{infoData.plateform.platform_name}}</span>
							</div>
							<div class="back" @click="goBack()">
								<i class="el-icon-back"></i>返回上一页
							</div>
						</div>
                    </div>
                    <div class="k-common-con">
                        <div class="k-table-wrapper">
                            <div class="whiteBox" style="padding-bottom: 0;">
                            	<div class="projectDetailTop">
									<div class="tyTitle">
										<p>基本信息</p>
									</div>
									<div class="detailBox">
										<ul>
											<li>
												<span class="title">平台名称：</span>
												<div class="con">{{infoData.plateform.platform_name}}</div>
											</li>
											<li>
												<span class="title">服务费率：</span>
												<div class="con">{{infoData.plateform.company_service_rate_txt}}</div>
											</li>
											<li>
												<span class="title">平台logo：</span>
												<div class="con" style="display: flex; align-items: center;">
													<img :src="infoData.plateform.attachment" alt="" width="20" height="20">
												</div>
											</li>
										</ul>
									</div>
									<template v-if="infoData.invoice && infoData.invoice.company_name">
										<div class="tyTitle">
											<p>发票信息</p>
										</div>
										<div class="detailBox">
											<ul>
												<li>
													<span class="title">公司：</span>
													<div class="con">{{infoData.invoice.company_name}}</div>
												</li>
												<li>
													<span class="title">单位地址：</span>
													<div class="con">{{infoData.invoice.address}}</div>
												</li>
												<li>
													<span class="title">税号：</span>
													<div class="con">{{infoData.invoice.ird}}</div>
												</li>
												<li>
													<span class="title">发票类型专票：</span>
													<div class="con">{{infoData.invoice.invoice_type_txt}}</div>
												</li>
												<li>
													<span class="title">返点发票税率：</span>
													<div class="con">{{infoData.invoice.invoice_rate_txt}}</div>
												</li>
												<li>
													<span class="title">银行账号：</span>
													<div class="con">{{infoData.invoice.bank_card}}</div>
												</li>
												<li>
													<span class="title">开户行：</span>
													<div class="con">{{infoData.invoice.bank_of_deposit_txt}}</div>
												</li>
												<li>
													<span class="title">开户支行：</span>
													<div class="con">{{infoData.invoice.bank_branch_txt}}</div>
												</li>
												<li>
													<span class="title">纳税人证明：</span>
													<div class="con">
														<el-link type="primary" :href="infoData.invoice.taxpayer_prove" target="_blank" v-if="infoData.invoice.taxpayer_prove!='--'">预览</el-link>
														<span v-else>--</span>
													</div>
												</li>
												<li>
													<span class="title">开户许可证：</span>
													<div class="con">
														<el-link type="primary" :href="infoData.invoice.invoice_prove" target="_blank" v-if="infoData.invoice.invoice_prove!='--'">预览</el-link>
														<span v-else>--</span>
													</div>
												</li>
												<li>
													<span class="title">状态：</span>
													<div class="con">{{infoData.invoice.status_txt}}</div>
												</li>
											</ul>
										</div>
									</template>
									<el-tabs v-model="bottomActiveName" @tab-click="changetype()">
									    <el-tab-pane label="对账记录" name="duizhang"></el-tab-pane>
									    <el-tab-pane label="导入刊例价记录" name="kanli"></el-tab-pane>
									</el-tabs>
									<div style="padding: 20px 0;" v-if="bottomActiveName == 'duizhang'">
										<el-table
										        :data="tableData.data"
										        style="width: 100%"
										        row-key="id"
										        border
										        stripe
												v-loading="loading"
										        ref = "table"
										        highlight-current-row
												@sort-change="sortChange">
											<el-table-column
													fixed
													prop="id"
													label="ID"
												    width="50">
											</el-table-column>
										    <el-table-column
										            fixed
										            prop="platform_id_txt"
										            label="所属平台"
										            min-width="200">
										    </el-table-column>
											<el-table-column
										            prop="execute_id_txt"
										            label="执行编码"
										            min-width="200">
										    </el-table-column>
											<el-table-column
										            fixed
										            prop="order_num"
										            label="订单编码"
										            min-width="200">
										    </el-table-column>
										    <el-table-column
										            prop="error_msg"
										            label="信息"
										            min-width="200">
													<template slot-scope="scope">
														<el-popover
														  placement="left"
														  width="330"
														  v-if="scope.row.error_msg.length > 0"
														  trigger="click">
														    <div class="ressupplier">
																<div v-for="(item,index) in scope.row.error_msg" :key="index">
																	<div class="str" style="font-weight: normal;">{{item}}</div>
																</div>
															</div>
															<el-button type="text" size="small" class="c-danger" slot="reference">查看详情</el-button>
														</el-popover>
													</template>
										    </el-table-column>
											<el-table-column
											        prop="uid_txt"
											        label="上传核对人"
											        min-width="100">
											</el-table-column>
										    <el-table-column
										            prop="status_txt"
										            label="状态"
										            width="100">
													<template slot-scope="scope">
														<el-tag type="success" size="mini" v-if="scope.row.status == 1">{{scope.row.status_txt}}</el-tag>
														<el-tag type="danger" size="mini" v-if="scope.row.status == 2">{{scope.row.status_txt}}</el-tag>
													</template>
										    </el-table-column>
										    <el-table-column
										            prop="create_time"
										            label="创建时间"
										            width="200"
										            sortable="custom">
										    </el-table-column>
										</el-table>
										<el-pagination
											background
											ref="pagination"
											@current-change="handleCurrentChange"
											:current-page="tableData.page | number"
											:page-size="tableData.pagesize | number"
											layout="total, prev, pager, next"
											:total="tableData.total | number">
										</el-pagination>
									</div>
									<div style="padding: 20px 0;" v-if="bottomActiveName == 'kanli'">
										<el-table
										        :data="tableData2.data"
										        style="width: 100%"
										        row-key="id"
										        border
										        stripe
										        ref = "table"
										        highlight-current-row
												v-loading="loading"
												@sort-change="sortChange2">
											<el-table-column
													fixed
													prop="id"
													label="ID"
													width="50">
											</el-table-column>
										    <el-table-column
										            fixed
										            prop="platform_name"
										            label="所属平台"
										            min-width="200">
										    </el-table-column>
											<el-table-column
										            prop="file_name"
										            label="文件名称"
										            min-width="200">
										    </el-table-column>
										    <el-table-column
										            prop="error_msg"
										            label="信息"
										            min-width="200">
													<template slot-scope="scope">
														<el-popover
														  placement="left"
														  width="330"
														  v-if="scope.row.error_msg && scope.row.error_msg.length > 0"
														  trigger="click">
														    <div class="ressupplier">
																<div v-for="(item,index) in scope.row.error_msg" :key="index">
																	<div class="str" style="font-weight: normal;">{{item}}</div>
																</div>
															</div>
															<el-button type="text" size="small" class="c-danger" slot="reference">查看详情</el-button>
														</el-popover>
														<span v-else>--</span>
													</template>
										    </el-table-column>
											<el-table-column
											        prop="uid_txt"
											        label="上传核对人"
											        min-width="100">
											</el-table-column>
										    <el-table-column
										            prop="status_txt"
										            label="状态"
										            width="100">
													<template slot-scope="scope">
														<el-tag type="success" size="mini" v-if="scope.row.status == 1">{{scope.row.status_txt}}</el-tag>
														<el-tag type="danger" size="mini" v-if="scope.row.status == 2">{{scope.row.status_txt}}</el-tag>
													</template>
										    </el-table-column>
										    <el-table-column
										            prop="create_time"
										            label="创建时间"
										            width="200"
										            sortable="custom">
										    </el-table-column>
										</el-table>
										<el-pagination
											background
											ref="pagination"
											@current-change="handleCurrentChange2"
											:current-page="tableData2.page | number"
											:page-size="tableData2.pagesize | number"
											layout="total, prev, pager, next"
											:total="tableData2.total | number">
										</el-pagination>
									</div>
								</div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
</div>
</template>
<script>
export default {
  data() {
      return {
          activeName: 'first',
          size:'mini',
  		  loading:false,
  		  infoData:{
			  invoice:{},
			  plateform:{}
  		  },
		  tableData: {
			  total: 0,
			  pagesize: 15,
			  page: 1,
			  data: []
		  },
		  tableData2: {
			  total: 0,
			  pagesize: 15,
			  page: 1,
			  data: []
		  },
		  bottomActiveName:'duizhang',
  		  queryParams:''//跳转页面携带参数
      }
  },
  computed: {
  },
  mounted: function () {
  	  this.loading = true
  	  this.queryParams = this.$route.query;
  	  this.getDetail()
	  this.handleSearch()
  },
  methods: {
  		//获取详情
  		getDetail(){
  			let params={}
  			params.platform_id = this.queryParams.id
  			this.$api.get('/admin/resources/resources/getplatforminfo',params).then(res => {
  				if (res.code === 0) {
  					this.infoData = res.data
  					this.loading = false
  				} else {
  				  this.$message.error(res.msg);
  				}
  			})
  		},
		goBack(){
			window.history.back()
		},
		//列表查询
		handleSearch(params, page, prop, order) {
			this.loading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			param['platform_id'] = this.queryParams.id
			this.$api.get('/admin/resources/resources/getplamteloglist',param).then(res => {
			   if (res.code == 0) {
				   this.tableData = res.data;		
			   }else{
				   this.$message.error(res.msg);
			   }
			   this.loading = false
			})
		},
		//列表查询
		handleSearch2(params, page, prop, order) {
			this.loading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			param['platform_id'] = this.queryParams.id
			this.$api.get('/admin/resources/resources/uploadpriceloglist',param).then(res => {
			   if (res.code == 0) {
				   this.tableData2 = res.data;		
			   }else{
				   this.$message.error(res.msg);
			   }
			   this.loading = false
			})
		},
		// 排序
		sortChange(e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
			  order = 'asc';
			} else if (e.order == 'descending') {
			  order = 'desc';
			} else {
			  prop = this.resetSearch.prop;
			  order = this.resetSearch.order;
			}
			this.handleSearch(this.searchForm, 1, prop, order);
		},
		// 排序
		sortChange2(e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
			  order = 'asc';
			} else if (e.order == 'descending') {
			  order = 'desc';
			} else {
			  prop = this.resetSearch.prop;
			  order = this.resetSearch.order;
			}
			this.handleSearch2(this.searchForm, 1, prop, order);
		},
		// 改变当前页 page
		handleCurrentChange(val) {
			this.handleSearch(this.searchForm, val);
		},
		// 改变当前页 page
		handleCurrentChange2(val) {
			this.handleSearch2(this.searchForm, val);
		},
		// 执行查询
		doSearch() {
			this.handleSearch(this.searchForm)
		},
		changetype(){
			if(this.bottomActiveName=='duizhang'){
				this.handleSearch()
			}else if(this.bottomActiveName == 'kanli'){
				this.handleSearch2()
			}
		}
  }
}
</script>
<style lang="scss" scoped>
.resourceCon{
	.addBox{
		margin-top: 60px;
	}
	.fyRadio{
		width: 94px;
		height: 40px;
		background: #fbfbfe;
		border: 1px solid #d7dae2;
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: center;
		img{
			width: 20px;
			    height: 20px;
			    margin-right: 6px;
		}
		.fyRadioTitle{
			font-size: 14px;
			font-weight: 400;
			color: #78859b;
		}
	}
	.el-radio{
		display: inline-flex;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 20px;
	}
}
.projectDetailInfo{
	position: relative;
	padding-left: 60px;
	height: 100%;
	margin-top: 20px;
	padding-bottom: 10px;
	.base-info-wrap{
	    margin-bottom: 10px;
		.row{
		    display: flex;
		    font-size: 14px;
		    align-items: center;
			flex-wrap: wrap;
			.column{
			    width: 20%;
				padding-bottom: 14px;
				.column-label{
				    margin-right: 14px;
				    color: #a1a1a1;
				}
				.column-value {
				    word-break: break-all;
				    color: #333;
					&.red {
					    color: #fb5555 !important;
					    font-weight: 500;
					}
				}
			}
		}
	}
	.bg{
	    position: absolute;
	    top: 0;
	    left: -24px;
	    width: 36px;
	    height: 100%;
	    background: url(../../assets/images/titbg.png) no-repeat;
	    background-size: 100% 100%;
	    writing-mode: vertical-lr;
	    display: flex;
	    justify-content: center;
	    align-items: center;
	    padding-left: 6px;
	    font-size: 14px;
	    text-indent: 10px;
	    letter-spacing: 12px;
	    color: #775905ec;
		border-radius:8px;
		overflow: hidden;
	}
	.des{
	    position: relative;
	    color: #333;
	    background: #f9fafd;
	    border-radius: 8px;
	    padding: 6px 10px;
	    line-height: 30px;
	    margin-top: -14px;
	    font-size: 14px;
		div{
		    white-space: pre-wrap;
		}
		span{
		    font-weight: bolder;
		    white-space: nowrap;
		}
		.desdemand {
		    padding: 10px;
		}
	}
}
.projectDetailCenter{
	display: flex;
	justify-content: space-between;
	.left{
		width: calc(100% - 370px);
		height: 240px;
	}
	.right{
		width: 350px;
		height: 240px;
	}
}
</style>